import { Button } from '@alicerce/ui';

export function LoadMore({ hasNextPage, isFetchingNextPage, fetchNextPage }: { hasNextPage: boolean; isFetchingNextPage: boolean; fetchNextPage: () => unknown }) {
  if (!hasNextPage) return null;
  return (
    <div className="flex justify-center border-t border-line p-3">
      <Button variant="secondary" size="sm" loading={isFetchingNextPage} onClick={() => fetchNextPage()}>
        Carregar mais
      </Button>
    </div>
  );
}
